import React, { Component } from "react";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

class SectionE extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { sectionE, onClickE, validateE } = this.props;
    return (
      <div>
        {sectionE && (
          <div className="form-wrapper-elevation">
            <h2>
              BUILDING ELEVATION INFORMATION (SURVEY NOT REQUIRED) FOR ZONE AO
              AND ZONE A (WITHOUT BFE){" "}
            </h2>
            {sectionE.isSubmittedE === false ? (
              <div className="err-msg-content">
                Something went wrong. Please try again.
              </div>
            ) : null}
            <table>
              <tbody>
                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <p className="sub-question-title">
                        For Zones AO and A (without BFE), complete Items E1–E5.
                        If the Certificate is intended to support a LOMA or
                        LOMR-F request, complete Sections A, B,and C. For Items
                        E1–E4, use natural grade, if available. Check the
                        measurement used. In Puerto Rico only, enter meters.
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>E1.</span>
                      <p className="qst-type">
                        {" "}
                        Provide elevation information for the following and
                        check the appropriate boxes to show whether the
                        elevation is above or below the highest adjacent grade
                        (HAG) and the lowest adjacent grade (LAG).
                      </p>{" "}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>(a)</span>
                      <label>
                        Top of bottom floor (including basement, crawlspace, or
                        enclosure) is
                      </label>
                      <div>
                        <input
                          type="text"
                          name="elevation_hag"
                          value={sectionE.elevation_hag}
                          onChange={onClickE}
                          className="form-input-box-small"
                        />
                        {validateE.message(
                          "unit",
                          sectionE.elevation_hag,
                          "numeric",
                          { className: "error-msg-text" }
                        )}
                      </div>

                      <div className="checkbox-container">
                        <input
                          checked={sectionE.elevation_hag_unit === "feet"}
                          type="radio"
                          name="elevation_hag_unit"
                          value="feet"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>

                        <input
                          checked={sectionE.elevation_hag_unit === "meters"}
                          type="radio"
                          name="elevation_hag_unit"
                          value="meters"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                        <input
                          checked={sectionE.elevation_hag_unit === "above or"}
                          type="radio"
                          name="elevation_hag_unit"
                          value="above or"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">above or</span>
                        <input
                          checked={
                            sectionE.elevation_hag_unit === "below the hag"
                          }
                          type="radio"
                          name="elevation_hag_unit"
                          value="below the hag"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">below the HAG.</span>
                        {validateE.message(
                          "unit",
                          sectionE.elevation_hag_unit,
                          "alpha_num_dash_space",
                          { className: "error-msg-text" }
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>(b)</span>
                      <label>
                        Top of bottom floor (including basement, crawlspace, or
                        enclosure) is
                      </label>
                      <div>
                        <input
                          type="text"
                          name="elevation_lag"
                          value={sectionE.elevation_lag}
                          onChange={onClickE}
                          className="form-input-box-small"
                        />
                        {validateE.message(
                          "unit",
                          sectionE.elevation_lag,
                          "numeric",
                          { className: "error-msg-text" }
                        )}
                      </div>

                      <div className="checkbox-container">
                        <input
                          checked={sectionE.elevation_lag_unit === "feet"}
                          type="radio"
                          name="elevation_lag_unit"
                          value="feet"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>

                        <input
                          checked={sectionE.elevation_lag_unit === "meters"}
                          type="radio"
                          name="elevation_lag_unit"
                          value="meters"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                        <input
                          checked={sectionE.elevation_lag_unit === "above"}
                          type="radio"
                          name="elevation_lag_unit"
                          value="above"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">above or</span>
                        <input
                          checked={sectionE.elevation_lag_unit === "below"}
                          type="radio"
                          name="elevation_lag_unit"
                          value="below"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">below the LAG.</span>
                        {validateE.message(
                          "unit",
                          sectionE.elevation_lag_unit,
                          "alpha_num_dash_space",
                          { className: "error-msg-text" }
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    {sectionE.answer9 === "no" ? (
                      <div className="question-wrapper">
                        <span>E2.</span>
                        <label>
                          For Building Diagrams 6–9 with permanent flood
                          openings provided in Section A Items 8 and/or 9 (see
                          pages 1–2 of Instructions),the next higher floor
                          (elevation C2.b in the diagrams) of the building is
                        </label>
                        <div>
                          <input
                            name="permanant_flood_openings"
                            value={sectionE.permanant_flood_openings}
                            disabled
                            type="text"
                            onChange={onClickE}
                            className="form-input-box-small"
                          />
                        </div>

                        <div className="checkbox-container">
                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit === "feet"
                            }
                            disabled
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="feet"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">feet</span>

                          <input
                            disabled
                            checked={
                              sectionE.permanant_flood_openings_unit ===
                              "meters"
                            }
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="meters"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">meters</span>
                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit === "above"
                            }
                            disabled
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="above"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">above or</span>
                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit === "below"
                            }
                            disabled
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="below"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">below the HAG.</span>
                        </div>
                      </div>
                    ) : sectionE.answer9 === "yes" ||
                      sectionE.answer9 === "" ||
                      sectionE.answer9 === null ? (
                      <div className="question-wrapper">
                        <span>E2.</span>
                        <label>
                          For Building Diagrams 6–9 with permanent flood
                          openings provided in Section A Items 8 and/or 9 (see
                          pages 1–2 of Instructions),the next higher floor
                          (elevation C2.b in the diagrams) of the building is{" "}
                        </label>{" "}
                        <div>
                          <input
                            name="permanant_flood_openings"
                            value={sectionE.permanant_flood_openings}
                            onChange={onClickE}
                            type="text"
                            className="form-input-box-small"
                          />
                          {validateE.message(
                            "unit",
                            sectionE.permanant_flood_openings,
                            "alpha_num_dash_space",
                            { className: "error-msg-text" }
                          )}
                        </div>
                        <div className="checkbox-container">
                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit === "feet"
                            }
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="feet"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />

                          <span className="checkbox-label">feet</span>

                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit ===
                              "meters"
                            }
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="meters"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">meters</span>
                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit === "above"
                            }
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="above"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">above or</span>
                          <input
                            checked={
                              sectionE.permanant_flood_openings_unit === "below"
                            }
                            type="radio"
                            name="permanant_flood_openings_unit"
                            value="below"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">below the HAG.</span>
                          {validateE.message(
                            "unit",
                            sectionE.permanant_flood_openings_unit,
                            "alpha_num_dash_space",
                            { className: "error-msg-text" }
                          )}
                        </div>
                      </div>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    {sectionE.answer1 === "no" ? (
                      <div className="question-wrapper">
                        <span>E3.</span>
                        <label>Attached garage (top of slab) is </label>
                        <input
                          type="text"
                          className="form-input-box-small"
                          value={sectionE.attached_garage_e3}
                          disabled
                          name="attached_garage_e3"
                          onChange={onClickE}
                        />

                        <div className="checkbox-container">
                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "feet"
                            }
                            disabled
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="feet"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">feet</span>

                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "meters"
                            }
                            disabled
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="meters"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">meters</span>
                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "above"
                            }
                            disabled
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="above"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">above or</span>
                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "below"
                            }
                            disabled
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="below"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">below the HAG.</span>
                        </div>
                      </div>
                    ) : sectionE.answer1 === "yes" ||
                      sectionE.answer1 === "" ||
                      sectionE.answer1 === null ? (
                      <div className="question-wrapper">
                        <span>E3.</span>
                        <label>Attached garage (top of slab) is </label>
                        <div>
                          <input
                            type="text"
                            className="form-input-box-small"
                            value={sectionE.attached_garage_e3}
                            onChange={onClickE}
                            name="attached_garage_e3"
                          />
                          {validateE.message(
                            "unit",
                            sectionE.attached_garage_e3,
                            "alpha_num_dash_space",
                            { className: "error-msg-text" }
                          )}
                        </div>

                        <div className="checkbox-container">
                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "feet"
                            }
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="feet"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">feet</span>

                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "meters"
                            }
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="meters"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">meters</span>
                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "above"
                            }
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="above"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">above or</span>
                          <input
                            checked={
                              sectionE.attached_garage_e3_unit === "below"
                            }
                            type="radio"
                            name="attached_garage_e3_unit"
                            value="below"
                            onChange={onClickE}
                            className="checkbox-icon-btn"
                          />
                          <span className="checkbox-label">below the HAG.</span>
                          {validateE.message(
                            "unit",
                            sectionE.attached_garage_e3_unit,
                            "alpha_num_dash_space",
                            { className: "error-msg-text" }
                          )}
                        </div>
                      </div>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>E4.</span>
                      <label>
                        Top of platform of machinery and/or equipment servicing
                        the building is{" "}
                      </label>
                      <div>
                        <input
                          type="text"
                          className="form-input-box-small"
                          name="equipment_serving"
                          value={sectionE.equipment_serving}
                          onChange={onClickE}
                        />
                        {validateE.message(
                          "unit",
                          sectionE.equipment_serving,
                          "numeric",
                          { className: "error-msg-text" }
                        )}
                      </div>

                      <div className="checkbox-container">
                        <input
                          checked={sectionE.equipment_serving_unit === "feet"}
                          type="radio"
                          name="equipment_serving_unit"
                          value="feet"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>

                        <input
                          checked={sectionE.equipment_serving_unit === "meters"}
                          type="radio"
                          name="equipment_serving_unit"
                          value="meters"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                        <input
                          checked={sectionE.equipment_serving_unit === "above"}
                          type="radio"
                          name="equipment_serving_unit"
                          value="above"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">above or</span>
                        <input
                          checked={sectionE.equipment_serving_unit === "below"}
                          type="radio"
                          name="equipment_serving_unit"
                          value="below"
                          onChange={onClickE}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">below the HAG.</span>
                        {validateE.message(
                          "unit",
                          sectionE.equipment_serving_unit,
                          "alpha_num_dash_space",
                          { className: "error-msg-text" }
                        )}
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>E5.</span>
                      <p className="qst-type">
                        Zone AO only: If no flood depth number is available, is
                        the top of the bottom floor elevated in accordance with
                        the community's floodplain management ordinance?
                      </p>
                    </div>

                    <div className="input-horizontal">
                      <input
                        checked={sectionE.floodplainmgt === "Yes"}
                        type="radio"
                        name="floodplainmgt"
                        value="Yes"
                        onChange={onClickE}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">Yes</span>
                      <input
                        checked={sectionE.floodplainmgt === "No"}
                        type="radio"
                        name="floodplainmgt"
                        value="No"
                        onChange={onClickE}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">No</span>{" "}
                      <input
                        checked={sectionE.floodplainmgt === "Unknown"}
                        type="radio"
                        name="floodplainmgt"
                        value="Unknown"
                        onChange={onClickE}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">Unknown</span>
                      {validateE.message(
                        "unit",
                        sectionE.floodplainmgt,
                        "alpha_num_dash_space",
                        { className: "error-msg-text" }
                      )}
                      <span className="check-label-note">
                        The local official must certify this information in
                        Section G.
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

export default SectionE;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionE.js